import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";

interface Document {
  title: string;
  type: string;
  url: string;
}

interface DocumentDownloadsProps {
  documents: Document[];
  companyName: string;
}

const DocumentDownloads = ({ documents, companyName }: DocumentDownloadsProps) => {
  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3">
            Wichtige Dokumente
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground">
            Alle Unterlagen zur {companyName} Cyberversicherung zum Download
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-3xl mx-auto">
          {documents.map((doc, index) => (
            <Card key={index} className="hover:shadow-lg transition-all duration-300 flex flex-col">
              <CardContent className="p-4 sm:p-5 lg:p-6 flex flex-col h-full">
                <div className="flex flex-col items-center text-center gap-3 sm:gap-4 flex-1">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0">
                    <FileText className="w-7 h-7 sm:w-8 sm:h-8 text-accent" />
                  </div>
                  <div className="flex-1 flex flex-col justify-center min-h-[80px]">
                    <h3 className="text-base sm:text-lg font-bold mb-1">
                      {doc.title}
                    </h3>
                    <p className="text-xs sm:text-sm text-muted-foreground">
                      {doc.type}
                    </p>
                  </div>
                  <Button 
                    variant="outline" 
                    className="w-full gap-2 mt-auto
                      bg-transparent
                      border border-white/20
                      text-white
                      hover:bg-transparent
                      hover:text-white
                      hover:border-accent
                      hover:shadow-[0_0_15px_rgba(139,195,74,0.4)]
                      transition-all duration-300"
                    asChild
                  >
                    <a href={doc.url} download target="_blank" rel="noopener noreferrer">
                      <Download className="w-4 h-4" />
                      <span className="text-sm sm:text-base">Download</span>
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DocumentDownloads;
